/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DynamicApplicationCreateDto } from '../../models/dynamic-application-create-dto';
import { DynamicApplicationDto } from '../../models/dynamic-application-dto';

export interface DynamicApplicationsIdPut$Params {
  id: number;
  body?: DynamicApplicationCreateDto;
}

export function dynamicApplicationsIdPut(
  http: HttpClient,
  rootUrl: string,
  params: DynamicApplicationsIdPut$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<DynamicApplicationDto>> {
  const rb = new RequestBuilder(rootUrl, dynamicApplicationsIdPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DynamicApplicationDto>;
    }),
  );
}

dynamicApplicationsIdPut.PATH = '/dynamic/applications/{id}';
